import { analytics } from '@lib/analytics/page-events';
import { Button } from 'ui-components';

const FAVORITE_BUTTON_CLASSNAME =
  'absolute right-2 top-2 z-20 border-0 bg-black/50 backdrop-blur-[2px] transition-opacity hover:bg-black/60 focus:bg-black/50 focus:ring-0 focus:ring-offset-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-focus active:bg-black/60 active:ring-0 active:ring-offset-0 md:h-10 md:w-10 md:opacity-0 md:focus-visible:opacity-100 md:group-focus-within:opacity-100 md:group-hover:opacity-100';

type ProductCardBookmarkButtonProps = {
  name: string;
  isFavorite: boolean;
  addToFavoritesLabel: string;
  removeFromFavoritesLabel: string;
  onFavorite?: () => void;
};

export const ProductCardBookmarkButton = ({
  name,
  isFavorite,
  addToFavoritesLabel,
  removeFromFavoritesLabel,
  onFavorite,
}: ProductCardBookmarkButtonProps) => (
  <Button.v2
    iconLeft="BookmarkSimple"
    iconWeight={isFavorite ? 'fill' : 'bold'}
    iconSize={24}
    size="small"
    shape="square"
    variant="primary"
    className={FAVORITE_BUTTON_CLASSNAME}
    iconClassName="text-white size-5 md:size-6"
    aria-label={isFavorite ? removeFromFavoritesLabel : addToFavoritesLabel}
    aria-pressed={isFavorite}
    data-testid="product-card-favorite-button"
    data-test="product-card-favorite-button"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      analytics.pushAddFavoriteEvent(name);
      onFavorite?.();
    }}
  />
);
